import {
    OrganizationProfile,
    OrganizationProfileSchema,
} from "@common/schemas/organization.schema";

type ProfileOverrides = Partial<OrganizationProfile>;

export function buildProfilePayload(
    profile: OrganizationProfile | null | undefined,
    overrides: ProfileOverrides,
): OrganizationProfile {
    return OrganizationProfileSchema.parse({
        ...(profile ?? {}),
        servicesOffered: profile?.servicesOffered ?? [],
        ...overrides,
    });
}
